
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';

import { LinkedinModule } from './linkedin/linkedin.module';
import { TwitterModule } from './twitter/twitter.module';


@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    LinkedinModule,
    TwitterModule,
  ],
  exports: [
    LinkedinModule,
    TwitterModule,
  ]
})
export class SocialModule {
}



// WEBPACK FOOTER //
// ./src/app/social/social.module.ts